import React, { createContext, useContext, useState, useEffect } from 'react';
import Localization from '../services/Localization';
import * as Components from '../resources/Components';

const CommonConfigContext = createContext();

function CommonConfigProvider({ children, locale: initialLocale }) {
    const [CommonConfigLoaded, setCommonConfigLoaded] = useState(false);
    const [labels, setLabels] = useState({});
    const storefrontNumber = null;
    const [locale, setLocale] = useState(initialLocale || 'en_US');

    useEffect(() => {
        const fetchLabels = async () => {
            try {
                const labels = await Localization.getComponentLabels(Components.COMMON, locale, storefrontNumber);
                setLabels(labels);
                setCommonConfigLoaded(true);
            } catch (error) {
                console.error("Error fetching Common settings:", error);
            }
        };

        fetchLabels();
    }, [locale]);

    const updateLocale = (newLocale) => {
        setLocale(newLocale);
    };
    return (
        <CommonConfigContext.Provider value={{ CommonConfigLoaded, labels, updateLocale }}>
            {children}
        </CommonConfigContext.Provider>
    );
}

function useCommonConfig() {
    const context = useContext(CommonConfigContext);
    if (context === undefined) {
        throw new Error('useCommonConfig must be used within a CommonConfigProvider');
    }
    return context;
}

function withCommonConfig(Component) {
    return function WrappedComponent(props) {
        const CommonConfig = useCommonConfig();
        return <Component {...props} CommonConfig={CommonConfig} />;
    };
}

export { CommonConfigProvider, useCommonConfig, withCommonConfig, CommonConfigContext };